var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToolCrosshair(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 11,10.631008 c 0.23,0 0.417,0.187 0.417,0.417 0,0.23 -0.187,0.417 -0.417,0.417 -0.23,0 -0.417,-0.187 -0.417,-0.417 0,-0.23 0.187,-0.417 0.417,-0.417"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7.8402736,11 -7.24425567,-2e-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 21.403981,11 -7.244255,-2e-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.922934,0.59601755 -10e-7,7.24425465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.922934,14.255744 -10e-7,7.244255"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolCrosshair);
export default __webpack_public_path__ + "static/media/tool-crosshair.a7f231614d7bb444a0bd88a346ffdc77.svg";
export { ForwardRef as ReactComponent };